var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.settings.loading)?_c('chart-report',{attrs:{"error":_vm.settings.tableData.error,"settings":_vm.settings.chartData,"partner":_vm.partner},on:{"change-map":function($event){return _vm.changeMap($event)}}}):_c('div',{staticClass:"w-100"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }